import { useMemo } from "react";
import { uuid } from "../services/helpers";

const useUuid = ():string => {
    return useMemo(() => uuid(), []);
}

export default useUuid;
